import { Checkbox } from "@chakra-ui/checkbox";
import React from "react";
import useFieldFast from "../../hooks/useFieldFast";
import useInProgressDisable from "../../hooks/useInProgressDisable";
import { YesNo } from "../../lib/models/enums";

export type CheckboxFieldProps = {
  label: string;
  name: string;
  errorText?: string;
  children?: any;
  disabled?: boolean;
};

function CheckboxField(props: CheckboxFieldProps) {
  const { label, name, children, disabled } = props;
  const [field, , helpers] = useFieldFast(props);
  const { value } = field;
  const { setValue } = helpers;

  const handleChange = (e: any) => {
    const checked = e.target.checked;
    const value = checked ? YesNo.Yes : YesNo.No;

    setValue(value);
  };

  return (
    <Checkbox
      id={name}
      isChecked={value === YesNo.Yes}
      {...field}
      onChange={handleChange}
      isDisabled={useInProgressDisable(name) || disabled}
    >
      {label}
      {children}
    </Checkbox>
  );
}

export default CheckboxField;
